export const api = {

  /* COMMON APIS */
  _permissionsAuth: 'admin/v1/admin/adminPermissions',
  _regions: 'admin/v1/business/region',
  _categories: 'admin/v1/business/categories',
  _assignedBusinessesList: 'admin/v1/admin/assignedBusinesses',

  /* LOGIN FLOW APIS*/
  _adminLogin: 'admin/v1/admin/login',
  _forgotPassword: 'admin/v1/admin/forgotPassword',
  _verifyOtp: 'admin/v1/admin/verifyOTP',
  _resetForgotPassword: 'admin/v1/admin/resetForgotPassword',
  _resendForgotPasswordOTP: 'admin/v1/admin/resendForgotPasswordOtp',
  _verifyTokenForResetPassword: 'admin/v1/admin/checkToken',
  _tokenProfile: 'admin/v1/admin/setupProfileToken',
  _setupAccount: 'admin/v1/admin/register',

  /* DELIVERY AGENT APIS */
  _deliveryAgent: 'admin/v1/deliveryAgent/listing',
  _addEditDeliveryAgent: 'admin/v1/deliveryAgent',
  _deliveryAgentDetails: 'admin/v1/deliveryAgent',
  _deliveryAgentEnableDisable: 'admin/v1/deliveryAgent/activate',
  _deliveryAgentResendInvite: 'admin/v1/deliveryAgent/resendInvite',
  _deliveryAgentChange: 'admin/v1/orders/deliveryAgentChange',
  _deliveryAgentOrders: 'admin/v1/deliveryAgent/orders',
  _deliveryAgentPickups: 'admin/v1/deliveryAgent/pickups',


  /* Business APIS */
  _business: 'admin/v1/business',
  _businessListing: 'admin/v1/business/listing',
  _businessDetails: 'admin/v1/business/details',
  _businessEnableDisable: 'admin/v1/business/activate',
  _businessResendInvite: 'admin/v1/business/resendInvite',
  _businessUser: 'admin/v1/business/adminUsers',
  _businessApproveDecline: 'admin/v1/business/businessApprovedDeclineByAdmin',
  _businessInventory: 'admin/v1/business/inventoryListing',
  _businessInventoryStatus: 'admin/v1/business/inventoryStatus',
  _businessInventoryPrice: 'admin/v1/business/inventoryPrice',
  _businessesExport: 'admin/v1/business/download',
  _businessPickups: 'admin/v1/business/pickups',
  _updateBusiness: 'admin/v1/business',
  _inventorySync: 'admin/v1/inventory/sync',
  _getBusinessCentralList: 'admin/v1/business/businesscentral/list',

  /* User and Roles Apis */
  _user: 'admin/v1/admin/listing',
  _userAddEdit: 'admin/v1/admin',
  _userActivateDeactive: 'admin/v1/admin/activate',
  _roles: 'admin/v1/roles',
  _userResendInvite: 'admin/v1/admin/resendInvite',


  /*  Broadcast Notifications apis */
  _broadcastBusinessList:"admin/v1/broadcast/businesses",
  _broadcastBusinessUsers:"admin/v1/broadcast/businessUsers",
  _broadcast:"admin/v1/broadcast",
  _broadcastDepartments:"admin/v1/broadcast/departments",
  _broadcastItems :"admin/v1/broadcast/inventoryItems",
  _broadcastResend:"admin/v1/broadcast/resend",

  /* Inventory APIS */
  _inventory: 'admin/v1/inventory/listing',
  _inventoryEnableDisable: 'admin/v1/inventory/stockStatus',

  /* Orders APIS */
  _orders: 'admin/v1/orders/listing',
  _orderDetails: 'admin/v1/orders',
  _cancelOrderReasons: 'admin/v1/orders/cancelReason',
  _cancelOrder: 'admin/v1/orders/cancelOrder',


  _resetPassword: 'admin/v1/admin/resetPassword',
  _changePassword: 'admin/v1/admin/profile/changePassword',
  _dashboard: 'admin/v1/dashboard',
  _currentProfile: 'admin/v1/admin/profile',

  // shipments api*/
  _addShipments: 'admin/v1/shipments',




  // replacement order api
  _cancelTickets: 'admin/v1/tickets/cancel',
  _cancelTicket: 'admin/v1/common/orderReasons',
  _addNewOrder: 'admin/v1/orders/placeOrder',
  _createPickup: 'admin/v1/tickets/approve',

  // ---- Quotations api's ---------
  _quotations: 'admin/v1/quotations',
  _quotationCount: 'admin/v1/quotations/pendingQuotationCount',


  // ---- Tickets api's ---------
  _replacementRequests: 'admin/v1/tickets',
  _otherTicketsForSameOrder: 'admin/v1/tickets/otherTicketsForSameOrder',
  _markResolved: 'admin/v1/tickets/close',
  _markInprogress: 'admin/v1/tickets/approve',

  // --- Cut Off api's --------
  _cutOffTime: 'admin/v1/settings',

  // ---- content Management api's ---------
  _getContentData: 'admin/v1/content',
  _getPageContent: 'admin/v1/admin/contents',


  // ----- Pickup Orders ------
  _pickupOrder: 'admin/v1/pickups/listing',
  _cancelPickup: 'admin/v1/pickups/updateStatus',
  _pickupDetails: 'admin/v1/pickups',
  _pickupChange: 'admin/v1/pickups/deliveryAgentChange',
   
  // ----- Dashboard  ------
  _getStats:"admin/v1/dashboard/stats",
  _getTopPerformingElements:"admin/v1/dashboard/topPerformingElements",
  _getPendingOrders:"admin/v1/dashboard/pendingOrders",
  _getRevenueTrend:"admin/v1/dashboard/revenueTrends",

  // ----- Pickup Orders ------
  // _pickupOrder: 'admin/v1/pickups/listing',
  // _cancelPickup: 'admin/v1/pickups/updateStatus',
  // _pickupDetails: 'admin/v1/pickups',
  // _pickupChange: 'admin/v1/pickups/deliveryAgentChange',

  // ------ Invoices ----
  _invoices: 'admin/v1/invoice/listing',
  _invoiceExport: '',
  _invoiceDetails: 'admin/v1/invoice',
  _invoiceDownload: 'admin/v1/invoice/invoiceDownload',

  _notification: 'admin/v1/notifications',
  _approveEditReq: 'admin/v1/notifications/approveBusinessRequest',
  _declineEditReq: 'admin/v1/notifications/declineBusinessRequest',
  _markRead: 'admin/v1/notifications/markRead',
  // _Notificationdetail: 'admin/v1/notification/detail',

  // -------- Category SubCategory ------------------
  _getCategories: "admin/v1/categories/listing",
  _category: "admin/v1/categories",
  _getSubCategoriesListing: "admin/v1/categories/subcategories/listing",
  _subCategory: "admin/v1/categories/subcategories",

  // -------------------------------------------
  _getcategiryDetails: 'admin/v1/categories/detail',
  _getSubCategories: 'admin/v1/common/getSubCategories',
  // _getSubCategoriesLevel2: 'admin/v1/common/getSubCategoriesLevel2',
  _categoriesBlockUnblock: 'admin/v1/categories/blockUnblock',
  // _getappversen: 'admin/v1/systemConfiguration/appVersion',
  // _getappVertionDetails: 'admin/v1/systemConfiguration/appVersion/detail',
  _uplod: 'admin/v1/common/getSignedURL',
  // _getDropDownData: 'admin/v1/common/allCommonData',
  // _getachievements: 'admin/v1/achievements',
  // _saveAchievement: 'admin/v1/achievements/',
  // _editAchievement: 'admin/v1/achievements/',
  // _getAchievementDetails: 'admin/v1/achievements/detail',
  // _getAchievementLevels: 'admin/v1/achievementLevels',
  // _getAchievementLevelDetails: 'admin/v1/achievementLevels/detail',

  // _getAchievementRules: 'admin/v1/achievementRules',
  // _getAchievementRulesDetails: 'admin/v1/achievementRules/detail',
  // _saveAchievementRules: 'admin/v1/achievementRules',
  // _editAchievementRules: 'admin/v1/achievementRules',
  // _getAchievementRuleDetails: 'admin/v1/achievementRules/detail',

  // _saveAchievementLevels: 'admin/v1/achievementLevels',
  // _editAchievementLevels: 'admin/v1/achievementLevels',

  _adminListing: 'admin/v1/admin',
  _adminDetail: 'admin/v1/admin',
  _adminDelete: 'admin/v1/admin',
  _addAdmin: 'admin/v1/admin',
  _editAdmin: 'admin/v1/admin',
  _updateAdmin: 'admin/v1/admin/edit-profile',

  _userListing: 'admin/v1/customers',
  _userBlock: 'admin/v1/customers/blockUnblock',
  _userDelete: 'admin/v1/customers',
  _userDetails: 'admin/v1/customers',
  _updatePassword: 'admin/v1/admin/profile/change-password',
  _updateProfile: 'admin/v1/admin/edit-profile',

  _putresetPassword: 'admin/v1/admin/profile/reset-password',
  // _getReportedItems: 'admin/v1/reportedItems',
  // _getReportedItemsDetails: 'admin/v1/reportedItems/detail',
  // _updateReportedItems: 'admin/v1/reportedItems',
  // _getReportedItemsCount: 'admin/v1/reportedItems/counts',

  // _getReportedBugs: 'admin/v1/reportedBugs',
  // _getReportedBugsDetails: 'admin/v1/reportedBugs/detail',
  // _updateReportedBugs: 'admin/v1/reportedBugs',
  // _getReportedBugsCount: 'admin/v1/reportedBugs/counts',
  // _getUserItemsCount: 'admin/v1/users/counts',
  _logoOut: 'admin/v1/admin/logout',
  _signedURL: 'admin/v1/common/getSignedURL',
  _addEditroles: 'admin/v1/roles',
  _permissions: 'admin/v1/common/permissions',
  _commonTags: 'admin/v1/tags',
  _commonRoles: 'admin/v1/common/roles',
  _tags: 'admin/v1/tags',
  _assignedToListing: 'admin/v1/tags/assignedToListing',
  _unAssign: 'admin/v1/tags/unAssign',
  _putresetPasswordnew: 'admin/v1/admin/reset-password',
  _subCategories: 'admin/v1/subCategories',
  _subCategoriesBlockUnblock: 'admin/v1/subCategories/blockUnblock',
  // _subCategorieslevel2: 'admin/v1/subCategories/level2',
  // _subCategoriesBlockUnblocklevel2: 'admin/v1/subCategories/level2/blockUnblock',
  _getListing: 'admin/v1/businessListing',
  _getListingDetails: 'admin/v1/businessListing/',
  _mediaMerchant: 'admin/v1/businessListing/v2',
  _updateListingStatus: 'admin/v1/businessListing/updateStatus',
  _businessActive: 'admin/v1/businessListing/activeDeactivate',
  _updateBasicDetails: 'admin/v1/businessListing/updateBasicDetails',
  _updateAdditionalDetails: 'admin/v1/businessListing/updateAdditionalDetails',
  _getBusiness: 'admin/v1/businessListing/getBusiness',
  _getHomeConfig: 'admin/v1/configuration/homepage/',
  // _getBusinessConfig: 'admin/v1/configuration/priority/',
  // _assignSubAdmin: 'admin/v1/businessListing/assignSubAdmin',
  // _businessListing: 'admin/v1/businessListing/',
  // _getPriority: 'admin/v1/configuration/priority/',

  // _getSubscriptionPlan: 'admin/v1/subscriptionPlan',
  // _topCategories: 'admin/v1/configuration/topCategoriesHome',
  // _verifyPhoneNumberBusiness: 'admin/v1/businessListing/verifyPhoneNumber',
  // _resendOtpBusiness: 'admin/v1/businessListing/resendOtpForVerification',
  // _checkEmail: 'admin/v1/businessListing/emailForVerification',
  // _otpForVerificationBussion: 'admin/v1/businessListing/otpForVerification',
  // _commonSubCategory: 'admin/v1/common/subcategoryLevel2',
  // _modeOfInteraction: 'admin/v1/modeOfInteractions',
  // _getAmenities: 'admin/v1/amenities',
  // _updateAddress: 'admin/v1/businessListing/updateAddress',
  // _paymentMethod: 'admin/v1/modeOfPayments',
  // _documentMaster: 'admin/v1/documentMaster',
  // _businessFormSettings: 'admin/v1/businessFormSettings',
  // _updateMedia: 'admin/v1/businessListing/updateMedia',
  // _updateDocuments: 'admin/v1/businessListing/updateDocuments',
  // _businessListingV2: 'admin/v1/businessListing/v2',
  // _serviceList: 'admin/v1/businessListing/service',
  // _offerAdd: 'admin/v1/businessListing/offerAndDiscounts',
  // _getOfferList: 'admin/v1/businessListing/offerAndDiscounts',
  // _getActivePlan: 'api/v1/subscription/getActiveSubscription',
  // _subscription: 'admin/v1/businessListing/subscription',
  // _subscriptionPlans: 'admin/v1/common/subscriptionPlans',
  // _ServiceApi: 'admin/v1/businessListing/service',
  // _activateDeactivate: 'admin/v1/businessListing/offerAndDiscounts/activateDeactivate',
  // _complimentarySubscription: 'admin/v1/businessListing/complimentarySubscription',
  // _sendSubscriptionPaymentLink: 'admin/v1/businessListing/sendSubscriptionPaymentLink',
  // _level2ProductAndServices: 'admin/v1/subCategories/level2ProductAndServices',

  // _getItemCode: 'api/v1/merchant/business/service/getItemCode',
  // _merchantSearchConfiguration: 'admin/v1/configuration/merchantSearchConfiguration',
  _downloadSampleBusinessCSV: 'admin/v1/businessListing/downloadSampleBusinessCSV',
  _uploadCSV: 'admin/v1/businessListing/uploadCSV',
  // _uploadCSVNew: 'admin/v1/businessListing/uploadCSVNew2',
  // _getGender: 'admin/v1/common/genders',
  // _getLanguage: 'admin/v1/common/languages',
  // _getReligion: 'admin/v1/common/religions',
  // _getEthnicity: 'admin/v1/common/ethnicities',
  // _getPersonalIncome: 'admin/v1/common/incomeRanges',
  // _getModeOfPayment: 'admin/v1/common/paymentMethods',
  // _getloanTypes: 'admin/v1/common/loanTypes',
  // _getMaritalStatus: 'admin/v1/common/maritalStatus',
  // _getCompanyType: 'admin/v1/common/autoMobileCompanies',
  // _getTwoWheelersCompanies: 'admin/v1/common/twoWheelersCompanies',
  // _getLifeInsurance: 'admin/v1/common/lifeInsuranceCompanies',
  // _getHealthInsurance: 'admin/v1/common/healthInsuranceCompanies',
  // _getCreditCardCompanies: 'admin/v1/common/creditCardCompanies',
  // _getVehcileModel: 'admin/v1/common/vehicleModels',
  // _getTypeOfJob: 'admin/v1/common/jobTypes',

  // _sports: 'admin/v1/common/sports',
  // _books: 'admin/v1/common/books',
  // _brands: 'admin/v1/common/clothingBrands',
  // _OTTplatformList: 'admin/v1/common/ottPlatforms',
  // _jobRoles: 'admin/v1/common/jobRoles',
  // _qualifications: 'admin/v1/common/qualifications',
  // _familyType: 'admin/v1/common/familyTypes',
  // _jobProfile: 'admin/v1/common/jobTypes',
  _auditlogs: 'admin/v1/common/activityLogs',

  _getReportedMerchant: 'admin/v1/reportedMerchants',
  // _deleteBusiness: 'admin/v1/reportedMerchants',
  // _rateReportedMerchant: 'admin/v1/reportedMerchants',
  // _suspendReportedMerchant: 'admin/v1/reportedMerchants',
  _activateOrDeactivateBusiness: 'admin/v1/reportedMerchants/blockUnblock',
  _businessClaims: 'admin/v1/businessClaims',
  // _sidebarCounts: 'admin/v1/common/sidebarCounts',
  // _getServiceApproval: 'admin/v1/serviceApprovals',
  // _businessCategories: 'admin/v1/businessListing/businessCategories',
  // _resendOtpEmail: 'api/v1/business/resendEmailForVerification',
  _verifyEmail: 'api/v1/business/verifyEmail',

  // _getNotification: 'admin/v1/notification',
  // _deleteNotification: 'admin/v1/notification',
  // _sendNotification: 'admin/v1/notification',

  // _adminBanner: 'admin/v1/advertisement/campaigns',
  // _getAdvertisementDemographicSettings: 'admin/v1/advertisement/getAdvertisementDemographicSettings',
  // _updateAdvertisementDemographicSettings: 'admin/v1/advertisement/updateAdvertisementDemographicSettings',
  // _merchantbanner: 'admin/v1/advertisement/campaigns',
  // _getStates: 'admin/v1/common/states',
  // _getCities: 'admin/v1/common/cities',
  // _bannerImage: 'admin/v1/advertisement/bannerImage',
  // _bannerTemplates: 'admin/v1/advertisement/templates',
  // _getAdvertisementPageSettings: 'admin/v1/advertisement/getAdvertisementPageSettings',
  // _updateAdvertisementPageSettings: 'admin/v1/advertisement/updateAdvertisementPageSettings',
  // _acceptRejectCampaign: 'admin/v1/advertisement/acceptRejectCampaign',
  // _businessDetail: 'admin/v1/common/businessDetail',
  // _getRatingAndReviews: 'admin/v1/common/getRatingAndReviews',
  // _adminCampaigns: 'admin/v1/advertisement/adminCampaigns',

  _checkAvailablePositions: 'admin/v1/advertisement/banner/checkAvailablePositions',
  _checkDatesAvailability: 'admin/v1/advertisement/banner/checkAvailability',

  _advertisementBanners: 'admin/v1/advertisement/banner',


  // _approvalBusinesses: 'admin/v1/businessListing/approvalBusinesses',
  // _searchBusiness: 'admin/v1/businessListing/searchBusiness',
  // _subscriptionPlanList: 'admin/v1/subscriptionPlan/list',
  // _subscriptionPlan: 'admin/v1/subscriptionPlan/plans',
  // _subscriptionPlanBlockUnblock: 'admin/v1/subscriptionPlan/plans/blockUnblock',
  // _subscriptions: 'admin/v1/subscriptionPlan',
  // _Image: 'admin/v1/advertisement/images',
  // _getPositionPrices: 'admin/v1/advertisement/getPositionPrices',
  // _uploadPositionPriceCSV: 'admin/v1/advertisement/uploadPositionPriceCSV',
  // _getPositionPricesCsvRecords: 'admin/v1/advertisement/getPositionPricesCsvRecords',
  // getPositionPricesCsvRecordDetails: 'admin/v1/advertisement/getPositionPricesCsvRecordDetails',
  // _commonBanner: 'admin/v1/advertisement/commonBanner',
  // _getInventoryReports: 'admin/v1/advertisement/getInventoryReports',
  // _queries: 'admin/v1/queries',
  // _reportedReviews: 'admin/v1/reportedReviews',
  // _getCampaignDetails: 'admin/v1/advertisement/getCampaignDetails',
  _frequentQuestion: 'admin/v1/faqs',
  // _userGuide: 'admin/v1/userGuide',
  // _paymentInfoSubscriptionListing: 'admin/v1/dashboard/paymentInfoSubscriptionListing',
  // _paymentAdsListing: 'admin/v1/dashboard/paymentAdsListing',
  // _getTopCategoriesListing: 'admin/v1/configuration/getTopCategoriesListing',
  // _updateTopCategoriesListing: 'admin/v1/configuration/updateTopCategoriesListing',
  // _adsImpressionsListing: 'admin/v1/dashboard/adsImpressionsListing',
  _topCategoriesHome: 'admin/v1/configuration/topCategoriesHome',
  _featuredCategories: 'admin/v1/configuration/featuredCategories',
  // _featuredCategoryDetail: 'admin/v1/configuration/featuredCategoryDetail',
  // _getLevelBenefits: 'admin/v1/tier/getLevelBenefits',
  // _updateLevelBenefits: 'admin/v1/tier/updateLevelBenefits',
  // _getEnangementPoints: 'admin/v1/tier/getEnangementPoints',
  // _addEnangementPoints: 'admin/v1/tier/addEnangementPoints',
  // _updateEnangementPoints: 'admin/v1/tier/updateEnangementPoints',
  // _getStageLevels: 'admin/v1/tier/getStageLevels',
  // _updateStageLevels: 'admin/v1/tier/updateStageLevels',
  // _getLevelCondition: 'admin/v1/tier/getLevelCondition',
  // _updateLevelCondition: 'admin/v1/tier/updateLevelCondition',
  // _getAvailableEnangementPoints: 'admin/v1/tier/getAvailableEnangementPoints',
  // _rewards: 'admin/v1/rewards/rewards',
  // _syncRewards: 'admin/v1/rewards/syncRewards',
  // _getRewardDetail: 'admin/v1/rewards/getRewardDetail',
  // _rewardCategories: 'admin/v1/rewards/rewardCategories',
  _settings: 'admin/v1/configuration/settings',
  _topBusinesses: 'admin/v1/configuration/topBusinesses',

  // _getRewardToken: 'admin/v1/rewards/getRewardToken',
  // _getRewardBrands: 'admin/v1/rewards/getRewardBrands',
  // _getThirdPartyRewards: 'admin/v1/rewards/getThirdPartyRewards',
  // _pullVoucherList: 'admin/v1/rewards/pullVoucherList',
  // _topCategoryDetail: 'admin/v1/configuration/topCategoryDetail',
  // _rewardBanners: 'admin/v1/rewardBanners',
  // _updateBannerPosition: 'admin/v1/rewardBanners/updateBannerPosition',
  // _leadManagement: 'admin/v1/leadManagement',
  // _leadConfigurations: 'admin/v1/leadManagement/leadConfigurations',
  // _updateSingleLeadPrice: 'admin/v1/leadManagement/updateSingleLeadPrice',
  // _CategoriesReport: 'admin/v1/categories/report',
  // _leadDenominations: 'admin/v1/leadManagement/leadDenominations',
  // _getTopSubcategoriesForLeadReports: 'admin/v1/leadManagement/getTopSubcategoriesForLeadReports',
  // _getTopLocationsForLeadReports: 'admin/v1/leadManagement/getTopLocationsForLeadReports',
  // _getPaidLeadMaster: 'admin/v1/leadManagement/getPaidLeadMaster',
  // _getDisableLeadPrices: 'admin/v1/leadManagement/getDisableLeadPrices',
  // _disableLeadPrices: 'admin/v1/leadManagement/disableLeadPrices',
  // _unDisableLeadPrice: 'admin/v1/leadManagement/unDisableLeadPrice',
  // _subscriptionPlansList: 'admin/v1/common/subscriptionPlansList',

  // _allSubscriptionPlansList: 'admin/v1/common/allSubscriptionPlansList',
  // _downloadSampleLeadPriceCSV: 'admin/v1/leadManagement/downloadSampleLeadPriceCSV',
  _seoLinks: 'admin/v1/seoLinks',
  // _commonBusinesses: 'admin/v1/common/businesses',
  // _commonAdmin: 'admin/v1/common/admins',
  // _getBusinessForSubCategoryLevelTwo: 'admin/v1/categories/report/getBusinessForSubCategoryLevelTwo',
  // _deleteThirdPartyRewards: 'admin/v1/rewards/deleteThirdPartyRewards',
  // _getUrlData: 'admin/v1/seoLinks/getDetails',
  // _downloadApprovalBusinesses: 'admin/v1/businessListing/downloadApprovalBusinesses',
  _downloadCategoriesListing: 'admin/v1/categories/downloadCategoriesListing',
  // _downloadReport: 'admin/v1/categories/downloadReport',

  // _downloadPaidLeadMaster: 'admin/v1/leadManagement/downloadPaidLeadMaster',
  // _downloadServicesCsv: 'admin/v1/serviceApprovals/downloadServicesCsv',
  // _downloadClaimBusinesses: 'admin/v1/businessClaims/downloadClaimBusinesses',
  // _downloadTopSubcategoriesForLeadReports: 'admin/v1/leadManagement/downloadTopSubcategoriesForLeadReports',
  // _downloadTopLocationsForLeadReports: 'admin/v1/leadManagement/downloadTopLocationsForLeadReports',

  // _downloadLeadPrices: 'admin/v1/leadManagement/downloadLeadPrices',
  // _downloadDisableLeadPrices: 'admin/v1/leadManagement/downloadDisableLeadPrices',
  // _downloadPositionPricesCsvRecords: 'admin/v1/advertisement/downloadPositionPricesCsvRecords',
  _downloadManageBusiness: 'admin/v1/businessListing/downloadManageBusiness',
}
